// extracted by mini-css-extract-plugin
module.exports = {"button":"SimplePopUp_button__1nQrD","dialog-wrapper":"SimplePopUp_dialog-wrapper__JhNyC","header":"SimplePopUp_header__16Z0K","secondary":"SimplePopUp_secondary__2BZn6"};